import { CourierProvider } from '@trycourier/react-provider'
import { useSession } from 'next-auth/react'
import { PropsWithChildren } from 'react'
import { useIsMobileWidth } from '@omnea-app/fe-browser-utils/useDetectDevice'
import { NotificationToast } from '../../headers/NotificationInbox'
import { CourierLocalStorage } from './helpers/CourierLocalStorage'
import { useInvalidateRequestsAndTasksQueries } from './useInvalidateRequestsAndTasksQueries'

export const NotificationProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const session = useSession()
  const user = session.data?.user
  const isMobile = useIsMobileWidth()
  const localStorage = new CourierLocalStorage()
  const invalidateQueries = useInvalidateRequestsAndTasksQueries()

  return (
    <CourierProvider
      userId={user?.metadata?.id}
      clientKey={process.env.COURIER_CLIENT_KEY}
      authorization={user?.metadata?.courierToken}
      localStorage={localStorage}
      onMessage={(message) => {
        invalidateQueries()
        return message
      }}
      wsOptions={{
        onError: (err) => {
          if (err.message === 'TIMEOUT') {
            console.info('Courier websocket timeout')
          } else {
            console.error('Courier websocket error', JSON.stringify(err))
          }
        },
      }}
    >
      {!isMobile && <NotificationToast />}
      {children}
    </CourierProvider>
  )
}
